import { 
    useTheme,
    Link as MUILink, 
} from "@mui/material";

const Link = ({ href, children, target = "_blank" }) => {
    const theme = useTheme();
    return (
        <MUILink href={href} target={target} rel="noreferrer" sx={theme.link}>
            {children || href}
        </MUILink>
    );
}

export default Link;